import React from 'react';

/**
 * Spinner.
 *
 * Eleven copies of the same div across the module, with one screen using an
 * orange border and the rest gray. `inherit` keeps it usable inside a
 * coloured button, which is what several of those copies were working around.
 */
const Spinner = ({ size = 'md', className = '', inherit = false }) => {
  const sizes = { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-8 w-8' };
  const color = inherit
    ? 'border-current border-t-transparent'
    : 'border-gray-300 dark:border-gray-600 border-t-gray-900 dark:border-t-white';

  return (
    <div
      role="status"
      aria-label="Loading"
      className={`animate-spin rounded-full border-2 ${color} ${sizes[size] || sizes.md} ${className}`}
    />
  );
};

/** Centred spinner for a loading region. */
export const LoadingBlock = ({ label = 'Loading…' }) => (
  <div className="flex flex-col items-center justify-center py-16 gap-3">
    <Spinner size="lg" />
    <p className="text-[13px] text-gray-500 dark:text-gray-400">{label}</p>
  </div>
);

export default Spinner;
